export default {
    topics: [
        {
            title: ' DOMDocument (Class) ',
            href: 'c-DOMDocument.html',
            attributes: { 'data-id': 'c-DOMDocument' },
            menu: { hasChildren: false },
            tocID: 'c-DOMDocument-d66e6887',
            next: 'c-DOMDocument-d66e6887',
        },
        {
            title: ' DOMNode (Class) ',
            href: 'c-DOMNode.html',
            attributes: { 'data-id': 'c-DOMNode' },
            menu: { hasChildren: false },
            tocID: 'c-DOMNode-d66e7064',
            next: 'c-DOMNode-d66e7064',
        },
        {
            title: ' DOMElement (Class) ',
            href: 'c-DOMElement.html',
            attributes: { 'data-id': 'c-DOMElement' },
            menu: { hasChildren: false },
            tocID: 'c-DOMElement-d66e7290',
            next: 'c-DOMElement-d66e7290',
        },
        {
            title: ' DOMAttr (Class) ',
            href: 'c-DOMAttr.html',
            attributes: { 'data-id': 'c-DOMAttr' },
            menu: { hasChildren: false },
            tocID: 'c-DOMAttr-d66e7467',
            next: 'c-DOMAttr-d66e7467',
        },
        {
            title: ' DOMCharacterData (Class) ',
            href: 'c-DOMCharacterData.html',
            attributes: { 'data-id': 'c-DOMCharacterData' },
            menu: { hasChildren: false },
            tocID: 'c-DOMCharacterData-d66e7515',
            next: 'c-DOMCharacterData-d66e7515',
        },
    ],
};

